import React, { useEffect, useState } from "react";
import UserWrapper from "./Rd.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import RdServices from "../../api/RdServices";
import RdAddForm from "../../components/rd/RdAddForm";
import EncryptDecrypt from "../../api/EncryptDecrypt";

const RdEdit = props => {
  const [editedData, setEditedData] = useState(undefined);
  const [stateList, setStateList] = useState([]);
  const [serviceLocationList, setServiceLocationList] = useState([]);
  const [timezoneList, setTimezoneList] = useState([]);
  const [languageList, setLanguageList] = useState([]);
  const hasParam = props.match.params.id;
  useEffect(() => {
    if (hasParam) {
      const params = {
        id: hasParam
      };
      RdServices.view(params).then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        setEditedData(data.data);
      });
    }
    RdServices.stateList().then(res => {
      let data = EncryptDecrypt.decrypt(res.data);
      setStateList(data.data);
    });
    RdServices.serviceLocationList().then(res => {
      let data = EncryptDecrypt.decrypt(res.data);
      setServiceLocationList(data.data);
    });
    RdServices.timezoneList().then(res => {
      let data = EncryptDecrypt.decrypt(res.data);
      setTimezoneList(data.data);
    });
    RdServices.languageList().then(res => {
      let data = EncryptDecrypt.decrypt(res.data);
      setLanguageList(data.data);
    });
  }, []);

  const submitFormHandler = (data, actionFlow, providerId) => {
    setTimeout(() => {
      props.history.push(`/rd/edit/${providerId?.id}`, {
        actionFlow: actionFlow,
        providerId: providerId?.id
      });
    }, 1000);
  };

  return (
    <UserWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          props={props}
          title="sidebar.provider"
          className="plr-15"
          breadCrumb={[
            {
              name: "sidebar.dashboard",
              url: "/dashboard"
            },
            {
              name: "sidebar.provider",
              url: "/rd"
            },
            {
              name: hasParam ? "action.edit" : "action.add"
            }
          ]}
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/rd")}
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>

      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> Add Provider
            </div>
          </div>
          <div className="roe-card-body">
            <RdAddForm
              onSubmit={submitFormHandler}
              editedData={editedData}
              action={hasParam ? "edit" : "add"}
              stateList={stateList || []}
              serviceLocationList={serviceLocationList || []}
              languageList={languageList || []}
              timezoneList={timezoneList || []}
              setServiceLocationList={setServiceLocationList}
              auth={props?.auth}
            />
          </div>
        </div>
      </div>
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state
  };
};

export default connect(mapStateToProps, null)(RdEdit);
